import { Burger, Button, Center, Group, rem, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconLanguage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import classes from './PublicNavbar.module.css';

export function PublicNavbar() {
  const navigate = useNavigate();
  // const { toggleColorScheme } = useMantineColorScheme();
  const { i18n, t } = useTranslation( 'layout' );
  const [ opened, { toggle }] = useDisclosure( false );
  const changeLanguage = () => {
    const currentLanguage = i18n.language;
    i18n.changeLanguage( currentLanguage === 'en' ? 'es' : 'en' );
  };

  const links = [
    { link: '/about', label: t( 'solutions_label' ) },
    { link: '/pricing', label: t( 'pricing_label' ) },
    { link: '/learn', label: t( 'learn_label' ) }
  ];

  const items = links.map(( link ) => (
    <a key={link.label} href={link.link} className={classes.link} onClick={( event ) => event.preventDefault()}>
      {link.label}
    </a>
  ));

  return (
    <header className={classes.header}>
      <div className={classes.inner}>
        <Group>
          <Burger opened={opened} onClick={toggle} size="sm" hiddenFrom="sm" />
          <Text fw={700} className={classes.application_name}>
            Teselly
          </Text>
          <Group ml={50} gap={5} className={classes.links} visibleFrom="sm">
            {items}
          </Group>
        </Group>

        <Group visibleFrom="sm">
          <Button variant="default" onClick={() => navigate( '/auth' )}>
            Log in
          </Button>
          <UnstyledButton onClick={changeLanguage}>
            <Center>
              <IconLanguage className={classes.icon} style={{ width: rem( 20 ), height: rem( 20 ) }} stroke={1.5} />
            </Center>
          </UnstyledButton>
          {/* <UnstyledButton onClick={toggleColorScheme}>
            <Center>
              <IconSun style={{ width: rem(20), height: rem(20) }} stroke={1.5} />
            </Center>
          </UnstyledButton> */}
        </Group>
      </div>
    </header>
  );
}
